'use client'

import { PackageResponseVo } from '@schemas/non-auth'
import Box from '@mui/joy/Box'
import UIFlex from '@components/ui/UIFlex'
import { pxToRem } from '@ui/style/muiTheme'
import UIChip from '@components/ui/UIChip'
import UILink from '@components/ui/UILink'
import SubSectionTitle from '@page/article/_components/common/SubSectionTitle'
import { getAreaParams } from '@utils/getLink'
import { AreaDiv } from '@services/api/Statistics/types'
import { scrollToTopAndEnableAutoScrollRestoration } from '@utils/scroll'

export interface RelatedIssueListProps {
	relatedIssue?: Array<PackageResponseVo>
	areaDiv?: AreaDiv
	areaIdx?: number
}
const RelatedIssueList = ({ relatedIssue, areaDiv, areaIdx }: RelatedIssueListProps) => {
	return (
		<Box mb={pxToRem(-8)}>
			<SubSectionTitle>관련 이슈</SubSectionTitle>
			<UIFlex
				flexDirection="row"
				flexWrap="wrap"
				sx={{
					'&>*:not(:last-child)': {
						marginRight: pxToRem(8),
					},
					'&>*': {
						marginBottom: pxToRem(8),
					},
				}}
			>
				{relatedIssue?.map((issue) => (
					<UIChip
						key={`related-issue-${issue.packageIdx}`}
						size="lg"
						color="point"
						slotProps={{
							action: {
								component: UILink,
								href: `/issues/${issue.packageIdx}?${getAreaParams(
									areaDiv,
									areaIdx,
								)}`,
							},
						}}
						onClick={scrollToTopAndEnableAutoScrollRestoration}
					>
						{issue.packageName}
					</UIChip>
				))}
			</UIFlex>
		</Box>
	)
}

export default RelatedIssueList
